import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorker from 'serviceWorker';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import 'antd/dist/antd.min.css';
import 'antd-overrides.css';

import Routes from 'routes';
const {
  REACT_APP_ENV = 'dev',
  REACT_APP_SENTRY_DSN,
  REACT_APP_NAME = 'client-web',
  REACT_APP_VERSION,
  REACT_APP_SENTRY_ERROR_SAMPLE_RATE = '1',
  REACT_APP_SENTRY_TRANSACTION_SAMPLE_RATE = '.2',
} = process.env;

const sanitizedAppName = REACT_APP_NAME.replace(/@\w+\//g, '');

Sentry.init({
  debug: ['dev', 'sandbox'].includes(REACT_APP_ENV),
  dsn: REACT_APP_SENTRY_DSN,
  environment: REACT_APP_ENV,
  release: `${sanitizedAppName}@${REACT_APP_VERSION}`,
  integrations: [new BrowserTracing()],
  sampleRate: Number.parseFloat(REACT_APP_SENTRY_ERROR_SAMPLE_RATE),
  tracesSampleRate: Number.parseFloat(REACT_APP_SENTRY_TRANSACTION_SAMPLE_RATE),
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>
);

if (process.env.NODE_ENV !== 'production') {
  import('@axe-core/react').then(({ default: axe }) =>
    axe(React, ReactDOM, 1000)
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
